<template>
  <div>
    <el-table :data="files" size="mini">
      <el-table-column
        :align="align"
        prop="key1"
        label="序号"
        type="index"
        width="50"
      ></el-table-column>
      <el-table-column
        :align="align"
        prop="fileName"
        label="附件名称"
      ></el-table-column>
      <el-table-column
        :align="align"
        prop="documentStatusShow"
        label="文件类型"
        width="180"
      ></el-table-column>
      <el-table-column
        :align="align"
        prop="createTime"
        label="上传时间"
      ></el-table-column>
      <el-table-column
        :align="align"
        prop="operationUserName"
        label="操作人"
      ></el-table-column>
      <el-table-column :align="align" prop="val3" label="操作" width="100">
        <template #default="{ row }">
          <el-button
            type="text"
            @click="
              checkAttach(row.fileId)
            "
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <my-image-view :show.sync="showViewer" :url-list="previewSrcList" />
  </div>
</template>

<script>
import MyImageView from "@/components/MyImageView.vue";
export default {
    components:{
        MyImageView
    },
  props: {
    waybillSplitId: {
    },
  },
  data(){
    return {
        align:'left',
        previewSrcList: [],
        files:[],
        showViewer:false
    }
  },
  watch: {
    waybillSplitId: {
      handler(val) {
        if (!val) {
        }
        this.getDetail();
      },
    },
  },
  mounted(){
    this.getDetail()
  },
  methods:{
    async checkAttach(fileId) {
      console.log(fileId)
      const rrr = await this.$API.wtl_getFileUrl({
        fileName: fileId,
      });
      this.fileUrls = [rrr.data.result.url];
      this.previewSrcList = this.fileUrls;
      this.showViewer = true;
    },
    async getDetail() {
      // const res = await this.$API.getWaybillDetail(this.waybillSplitId);
      // this.baseInfo = res.baseInfo;
      // this.files = res.files || [];
    if(!this.waybillSplitId){
      return;
    }
      this.getBillPackFileListV2()
    },
    getBillPackFileListV2() {
      this.$API
        .wtl_getWaybillFiles({
          waybillSplitId: this.waybillSplitId,
        })
        .then( async (res) => {
          this.files = res.data.result || [];
        });
    },
  }
};
</script>

<style>
</style>